export default {
    url: '/submission?guid',
    template: `
                <div ng-if="vm.isCertificationForm" class="col00">
                    <quiz form-submission="vm.formSubmission"/>
                </div>
                <div ng-if="vm.isEvaluationForm" class="col00">
                    <evaluation-public-evaluation form-submission="vm.formSubmission" company="vm.company"/>
                </div>
                <div ng-if="vm.isSurveyForm" class="col00">
                    <survey-public-survey form-submission="vm.formSubmission"/>
                </div>
                <div ng-if="vm.isCertificationFeedbackForm" class="col00">
                    <feedback-form form-submission="vm.formSubmission"/>
                </div>
                `,
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            // TODO :: consider reducing shown fields, all fields should not be seen by another person
            // TODO :: formI18ns need for trial only, did not find the way of defining the trial here
            return FormSubmissionResource.start({ guid: $stateParams.guid, expand: 'form,formI18ns' }).$promise;
        },
        company (CompanyResource, TokenService) {
            return CompanyResource.publicView({ id: TokenService.getCompanyId(), expand: 'companyI18ns' }).$promise;
        }
    },
    controller (formSubmission, FormService, company) {
        this.formSubmission = formSubmission;
        this.isCertificationForm = FormService.isCertificationForm(formSubmission.form);
        this.isCertificationFeedbackForm = FormService.isCertificationFeedbackForm(formSubmission.form);
        this.isEvaluationForm = FormService.isEvaluationForm(formSubmission.form);
        this.isSurveyForm = FormService.isSurveyForm(formSubmission.form);
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/submission/index.js